import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from '@react-native-async-storage/async-storage'; // or the storage you are using
import authReducer from './slices/authSlice';
import errorReducer from './slices/errorSlice';
import commonReducer from './slices/commonSlice';
import firebaseReducer from './slices/firebaseParamsSlice';
import platformParamsReducer from './slices/platformSlice';
import pledgeLimitReducer from './slices/pledgeLimit';
import applicationReducer from './slices/applicationSlice';
import { combineReducers } from 'redux';
// @ts-ignore
import { createLogger } from 'redux-logger';
import * as Sentry from "@sentry/react-native";
import { Platform } from 'react-native';

const persistConfig = {
  key: 'root',
  storage,
  whitelist : ['auth', 'pledgeLimit']
};

const rootReducer = combineReducers({
  errorSheet: errorReducer,
  auth: authReducer,
  platformParams: platformParamsReducer,
  pledgeLimit: pledgeLimitReducer,
  application: applicationReducer,
  commonReducer : commonReducer,
  firebaseParams: firebaseReducer,
});

const loggerMiddleware = createLogger({
  predicate: () => true,
  timestamp: true,
  diff: true,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
   middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(),
 
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(Sentry.createReduxEnhancer({ attachReduxState: true, stateTransformer: (state) => ({plaformParams: state.platformParams}) }));
  },
  devTools: Platform.OS === 'web' ? process.env.NODE_ENV !== 'production' : false,
});

const persistor = persistStore(store);

export { store, persistor };

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch